import {H1} from '@jetbrains/ring-ui/components/heading/heading'
import classNames from 'classnames'
import * as React from 'react'

import {useSandbox} from '../../../utils/fastdom'

import DefaultUISvg from './default-ui.svg'

import styles from './UIPlaceholder.css'

type Props = {
  infoContainerClassName?: string
  children?: React.ReactNode
  title: string
}
const BOTTOM_GAP = 150

function UIPlaceholder({children, title, infoContainerClassName}: Props) {
  const [availableHeight, setAvailableHeight] = React.useState<number | undefined>()
  const sandbox = useSandbox()
  React.useEffect(() => {
    const main = document.getElementById('main-content-tag')

    const updateHeight = () => {
      if (main) {
        sandbox.measure(() => {
          const clientRect = main.getBoundingClientRect()
          setAvailableHeight(clientRect.height - BOTTOM_GAP)
        })
      }
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => {
      window.removeEventListener('resize', updateHeight)
    }
  }, [sandbox])

  if (availableHeight == null && !IS_STORYBOOK) {
    return null
  }

  return (
    <div
      className={styles.wrapper}
      style={{
        minHeight: availableHeight,
      }}
    >
      <div className={classNames(styles.svgContainer, styles.defaultUi)}>
        <DefaultUISvg />
      </div>
      <div className={classNames(styles.infoContainer, infoContainerClassName)}>
        <H1>{title}</H1>
        {children}
      </div>
    </div>
  )
}

export default UIPlaceholder
